import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight, Star } from "lucide-react";
import { Reviews } from "@/components/Reviews";
import { Footer } from "@/components/Footer";

export default function Clienti() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-ink text-foreground" data-testid="clienti-page">
      <header className="border-b border-white/10 bg-surface sticky top-0 z-50">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="clienti-logo-link">
            <Star className="w-5 h-5 text-gold fill-gold" strokeWidth={1} />
            <span className="font-oswald text-lg tracking-[0.25em] uppercase">
              Star <span className="text-gold">Edil</span>
            </span>
          </Link>
          <Link
            to="/"
            data-testid="clienti-back-link"
            className="flex items-center gap-2 font-oswald uppercase text-xs tracking-[0.2em] text-muted-foreground hover:text-gold transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Torna al sito
          </Link>
        </div>
      </header>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
        className="max-w-[1600px] mx-auto px-6 lg:px-12 pt-20 lg:pt-28"
      >
        <p className="font-oswald text-gold uppercase tracking-[0.35em] text-sm mb-6">Clienti soddisfatti</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight max-w-4xl" data-testid="clienti-title">
          La miglior pubblicità è una <span className="text-gold italic">casa consegnata bene.</span>
        </h1>
        <p className="mt-8 max-w-xl text-base md:text-lg text-muted-foreground leading-relaxed">
          Le parole di chi ci ha affidato la propria casa: cantieri chiusi nei tempi, preventivi rispettati e
          chiavi consegnate senza pensieri.
        </p>
      </motion.div>

      <Reviews />

      <section className="py-20 lg:py-28">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 text-center">
          <p className="font-display italic text-2xl md:text-3xl text-muted-foreground mb-10">
            Il prossimo cliente soddisfatto potresti essere tu.
          </p>
          <Link
            to="/#preventivo"
            data-testid="clienti-cta-quote"
            className="btn-tracer inline-flex items-center gap-3 bg-gold text-ink font-oswald uppercase tracking-[0.15em] px-9 py-4 hover:bg-gold-hover transition-colors duration-300"
          >
            Richiedi un preventivo <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>

      <Footer />
    </main>
  );
}
